import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core'
import config from '../../config/config.json';

export default function (props) {
    const ejemplo = [
        [
            { campo: 'id', tipo: 'integer', valor: '19', descripcion: 'Identificador del pronóstico.' },
            { campo: 'fecha', tipo: 'date', valor: '25-01-2021', descripcion: 'Fecha del pronóstico.' },
            { campo: 'fiabilidad', tipo: 'integer', valor: '80', descripcion: 'Fiabilidad del pronóstico expresada en %.' },
            { campo: 'comentario', tipo: 'string', valor: '', descripcion: 'Texto que describe las variables pronosticadas.' },
            { campo: 'meteorologo', tipo: 'string', valor: 'Virginia Vinajera Suarez', descripcion: 'Quien elabora el pronóstico.' },
            { campo: 'tempMin', tipo: 'float', valor: '22', descripcion: 'Valor de la temperatura mínima.' },
            { campo: 'tempMax', tipo: 'float', valor: '31', descripcion: 'Valor de la temperatura máxima.' },
            { campo: 'tempAmb', tipo: 'float', valor: '27', descripcion: 'Valor de la temperatura ambiente.' },
            { campo: 'sConfort', tipo: 'float', valor: '28', descripcion: 'Sensacion de confort.' },
            { campo: 'humedad', tipo: 'float', valor: '65', descripcion: 'Valor de la humedad relativa expresada en %' },
            { campo: 'presion', tipo: 'float', valor: '1013', descripcion: 'Valor de la presion atmosférica.' },
            { campo: 'precipitaciones', tipo: 'string', valor: 'No lloverá', descripcion: 'Comportamiento de las precipitaciones.' },
            { campo: 'vientoMin', tipo: 'float', valor: '0', descripcion: 'Valor mínimo de la velocidad del viento.' },
            { campo: 'vientoMax', tipo: 'float', valor: '4', descripcion: 'Valor máximo de la velocidad del viento.' },
            { campo: 'dir_viento', tipo: 'string', valor: 'N', descripcion: 'Dirección del viento.' },
            { campo: 'nubosidad', tipo: 'string', valor: 'Despejado', descripcion: 'Valor de la nubosidad.' },
            { campo: 'mar', tipo: 'string', valor: 'Mar tranquila', descripcion: 'Comportamiento del mar.' },
            { campo: 'luna', tipo: 'string', valor: 'Nueva', descripcion: 'Fase por la que transita la luna.' },
            { campo: 'visibilidad', tipo: 'float', valor: '2', descripcion: 'Valor de la visibilidad expresadda en km' },
            { campo: 'salidaSol', tipo: 'string', valor: '06:45 AM', descripcion: 'Hora a la que sale el Sol para la fecha de este pronóstico.' },
            { campo: 'puestaSol', tipo: 'string', valor: '06:45 PM', descripcion: 'Hora a la que se pone el Sol para la fecha de este pronóstico.' },
        ],
        [
            //
        ],
        [
            //
        ],
        [
            // 
        ],
    ];
    /**
     * [
    {
        "id": "19",
        "fecha": "",
        "fiabilidad": "80",
        "comentario": "",
        "meteorologo": "Admin",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "",
        "mar": "",
        "luna": "",
        "visibilidad": "2",
        "salidaSol": "10:00 PM",
        "puestaSol": "10:00 PM"
    },
    {
        "id": "18",
        "fecha": "24-01-2021",
        "fiabilidad": "80",
        "comentario": "",
        "meteorologo": "villi",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "No lloverá",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Despejado",
        "mar": "Mar tranquila",
        "luna": "Nueva",
        "visibilidad": "2",
        "salidaSol": "12:55 AM",
        "puestaSol": "12:55 AM"
    },
    {
        "id": "17",
        "fecha": "23-01-2021",
        "fiabilidad": "80",
        "comentario": "",
        "meteorologo": "villi",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "No lloverá",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Despejado",
        "mar": "Mar tranquila",
        "luna": "Nueva",
        "visibilidad": "2",
        "salidaSol": "12:55 AM",
        "puestaSol": "12:55 AM"
    },
    {
        "id": "16",
        "fecha": "22-01-2021",
        "fiabilidad": "80",
        "comentario": "",
        "meteorologo": "villi",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "No lloverá",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Despejado",
        "mar": "Mar tranquila",
        "luna": "Nueva",
        "visibilidad": "2",
        "salidaSol": "12:55 AM",
        "puestaSol": "12:55 AM"
    }



    // Municipios
    {
    "1": {
        "id": "2",
        "fecha": "14-03-2020",
        "fiabilidad": "90",
        "municipio": "Santiago de Cuba",
        "meteorologo": "Virginia Vinajera Suárez",
        "tempMin": "26",
        "tempMax": "32",
        "tempAmb": "29",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1011",
        "precipitaciones": "Algunos",
        "vientoMin": "5",
        "vientoMax": "7",
        "dir_viento": "NE",
        "nubosidad": "Poco Nublado",
        "visibilidad": "8"
    },
    "2": {
        "id": "7",
        "fecha": "14-03-2020",
        "fiabilidad": "80",
        "municipio": "Guamá",
        "meteorologo": "villi",
        "tempMin": "28",
        "tempMax": "33",
        "tempAmb": "30",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "Lluvia de granizos",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Despejado",
        "visibilidad": "2"
    },
    "3": {
        "id": "3",
        "fecha": "14-03-2020",
        "fiabilidad": "89",
        "municipio": "Songo la Maya",
        "meteorologo": "villi",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "26",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "No lloverá",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Despejado",
        "visibilidad": "11"
    },
    "4": {
        "id": "8",
        "fecha": "14-03-2020",
        "fiabilidad": "94",
        "municipio": "San Luis",
        "meteorologo": "villi",
        "tempMin": "28",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "80",
        "presion": "1013",
        "precipitaciones": "Intensas con (TE)",
        "vientoMin": "6",
        "vientoMax": "10",
        "dir_viento": "O",
        "nubosidad": "Despejado",
        "visibilidad": "18"
    },
    "5": {
        "id": "9",
        "fecha": "14-03-2020",
        "fiabilidad": "76",
        "municipio": "Palma Soriano",
        "meteorologo": "villi",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "90",
        "presion": "1008",
        "precipitaciones": "Algunos",
        "vientoMin": "4",
        "vientoMax": "21",
        "dir_viento": "S",
        "nubosidad": "Parcialmente Nublado",
        "visibilidad": "19"
    },
    "6": {
        "id": "12",
        "fecha": "14-03-2020",
        "fiabilidad": "44",
        "municipio": "III Frente",
        "meteorologo": "villi",
        "tempMin": "32",
        "tempMax": "41",
        "tempAmb": "36",
        "sConfort": "34",
        "humedad": "100",
        "presion": "886",
        "precipitaciones": "Intensas con (TE)",
        "vientoMin": "53",
        "vientoMax": "72",
        "dir_viento": "O",
        "nubosidad": "Nublado",
        "visibilidad": "1"
    },
    "7": {
        "id": "10",
        "fecha": "14-03-2020",
        "fiabilidad": "80",
        "municipio": "Contramaestre",
        "meteorologo": "",
        "tempMin": "22",
        "tempMax": "31",
        "tempAmb": "27",
        "sConfort": "28",
        "humedad": "78",
        "presion": "1007",
        "precipitaciones": "Aisladas",
        "vientoMin": "0",
        "vientoMax": "13",
        "dir_viento": "SO",
        "nubosidad": "Poco Nublado",
        "visibilidad": "16"
    },
    "8": {
        "id": "6",
        "fecha": "14-03-2020",
        "fiabilidad": "96",
        "municipio": "Mella",
        "meteorologo": "villi",
        "tempMin": "25",
        "tempMax": "32",
        "tempAmb": "28",
        "sConfort": "28",
        "humedad": "65",
        "presion": "1019",
        "precipitaciones": "Intensas",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "N",
        "nubosidad": "Nublado",
        "visibilidad": "7"
    },
    "9": {
        "id": "4",
        "fecha": "14-03-2020",
        "fiabilidad": "96",
        "municipio": "II Frente",
        "meteorologo": "villi",
        "tempMin": "24",
        "tempMax": "29",
        "tempAmb": "25",
        "sConfort": "30",
        "humedad": "65",
        "presion": "1013",
        "precipitaciones": "Numerosas",
        "vientoMin": "0",
        "vientoMax": "4",
        "dir_viento": "NE",
        "nubosidad": "Parcialmente Nublado",
        "visibilidad": "2"
    }
}
]
     */
    const ejemploMun = [
        [
            { campo: 'id', tipo: 'integer', valor: '2', descripcion: 'Identificador del pronóstico.' },
            { campo: 'fecha', tipo: 'date', valor: '14-03-2020', descripcion: 'Fecha del pronóstico.' },
            { campo: 'fiabilidad', tipo: 'integer', valor: '90', descripcion: 'Fiabilidad del pronóstico expresada en %.' },
            { campo: 'municipio', tipo: 'string', valor: 'Santiago de Cuba', descripcion: 'Municipio para el cual es el pronóstico.' },
            { campo: 'meteorologo', tipo: 'string', valor: 'Virginia Vinajera Suarez', descripcion: 'Quien elabora el pronóstico.' },
            { campo: 'tempMin', tipo: 'float', valor: '26', descripcion: 'Valor de la temperatura mínima.' },
            { campo: 'tempMax', tipo: 'float', valor: '32', descripcion: 'Valor de la temperatura máxima.' },
            { campo: 'tempAmb', tipo: 'float', valor: '29', descripcion: 'Valor de la temperatura ambiente.' },
            { campo: 'sConfort', tipo: 'float', valor: '28', descripcion: 'Sensacion de confort.' },
            { campo: 'humedad', tipo: 'float', valor: '65', descripcion: 'Valor de la humedad relativa expresada en %' },
            { campo: 'presion', tipo: 'float', valor: '1011', descripcion: 'Valor de la presion atmosférica.' },
            { campo: 'precipitaciones', tipo: 'string', valor: 'Algunos', descripcion: 'Comportamiento de las precipitaciones.' },
            { campo: 'vientoMin', tipo: 'float', valor: '5', descripcion: 'Valor mínimo de la velocidad del viento.' },
            { campo: 'vientoMax', tipo: 'float', valor: '7', descripcion: 'Valor máximo de la velocidad del viento.' },
            { campo: 'dir_viento', tipo: 'string', valor: 'NE', descripcion: 'Dirección del viento.' },
            { campo: 'nubosidad', tipo: 'string', valor: 'Poco Nublado', descripcion: 'Valor de la nubosidad.' },
            { campo: 'visibilidad', tipo: 'float', valor: '8', descripcion: 'Valor de la visibilidad expresadda en km' },
        ],
        [
            //
        ],
        [
            //
        ],
        [
            // 
        ],
    ];

    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Pronóstico Extendido
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Pronóstico para los próximos días.
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/pronostico/pronextendido</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/pronostico/pronextendido`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/pronostico/pronextendido
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve los últimos 4 pronósticos efectuados para la provincia. Donde cada pronóstico es representado por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo de respuesta: <br />
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                {
                    ejemplo.map((item) => (
                        <>
                            <div>{`{`}</div>
                            {
                                item.map((subitem) => (
                                    <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                ))
                            }
                            <div>{`}`},</div>
                        </>
                    ))
                }
                ]
            </pre>

            <Typography variant="subtitle1" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemplo.map((item, index) => {
                            if (index == 0) {
                                return (
                                    item.map((subitem) => (
                                        <tr>
                                            <td>{subitem.campo}</td>
                                            <td>{subitem.tipo}</td>
                                            <td>{subitem.descripcion}</td>
                                        </tr>
                                    ))
                                )
                            }
                        })
                    }
                </tbody>
            </table>
            <br />
            <br />

            {/* otro ejemplo de peticion */}
            <Typography variant="subtitle1" color="initial">
                <strong>
                    Obteniendo una cantidad de pronósticos deseada.
                </strong>
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/pronostico/pronextendido/{`{`}cant{`}`}</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/pronostico/pronextendido/5`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/pronostico/pronextendido/{`{`}cant{`}`}
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve las últimas <code>{`{ `}cant{` }`}</code> pronósticos en caso de que existan; de lo contrario una lista vacía <code>[ ]</code>.
            </Typography>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de url para obtener las 3 últimos pronósticos: <br />
            </Typography>
            <br />

            <pre>
                {config.apiBaseUrl}/pronostico/pronextendido/3
            </pre>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de respuesta. <br />
            </Typography>
            <br />

            <pre>
                Ver ejemplo anterior, estando limitada la cantidad de pronósticos a 3.
            </pre>
            <br />
            <br />
            <br />



















            {/* Pronóstico Municipios */}
            <Typography variant="h5" color="initial">
                <code>
                    Pronóstico por municipios
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Pronóstico detallado a nivel municipal.
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/pronostico/prontodosmun</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/pronostico/prontodosmun`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/pronostico/prontodosmun
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve el último pronóstico efectuado para los municipios en cuestión. Donde cada pronóstico es representado por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo de respuesta: <br />
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                {`{`}
                {
                    ejemploMun.map((item, index) => (
                        <>
                            <div><span className="pre-key">"{index + 1}"</span>: {`{`}</div>
                            {
                                item.map((subitem) => (
                                    <div><span className="pre-key" style={{paddingLeft: 40}}>"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                ))
                            }
                            <div style={{paddingLeft: 32}}>{`}`},</div>
                        </>
                    ))
                }
                {`}`}
            </pre>

            <Typography variant="subtitle1" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemploMun.map((item, index) => {
                            if (index == 0) {
                                return (
                                    item.map((subitem) => (
                                        <tr>
                                            <td>{subitem.campo}</td>
                                            <td>{subitem.tipo}</td>
                                            <td>{subitem.descripcion}</td>
                                        </tr>
                                    ))
                                )
                            }
                        })
                    }
                </tbody>
            </table>
            <br />
        </>
    )
}